import "./index.css"

import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const Spacer = ({ size }) => (jsx("div", { className: classNames('cds-spacer', `cds-spacer--${size}`) }));

export { Spacer };
